import {userConstants} from "../constants/user.constants";

const initState = {
    userList: null,
    getById: null,
};

export function userReducer(state = initState, action) {
    switch (action.type) {
        case userConstants.USER_LIST_SUCCESS:
            console.log(action);
            return  {
                ...state,
                userList: action.userModel,
            };
        case userConstants.USER_LIST_REQUEST:
        case userConstants.USER_LIST_FAILURE:
            return {
                ...state,
                userList: null
            };
        case userConstants.USER_GET_BY_ID_SUCCESS:
            return {
                ...state,
                getById: action.userModel
            };
        case userConstants.USER_GET_BY_ID_CLEAR:
            return {
                ...state,
                getById: null
            };
        default: {
            return state
        }
    }
}
